/*
  created by Rija
  added on 2/1/2021
  @desc meter main page to swtich between different options
*/

import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { ButtonGroup, Button } from 'react-bootstrap';
import { ColorButton, FiltersContainer, HeadingContainer, SearchContainer } from '../../../../neoverv';
import Autoload from '../../../../neoverv/Autoload';
import { withRouter } from 'react-router-dom';
import MessagingEditor from './MessagingEditor';
import MessagesList from './MessagesList';
import NewMessage from './NewMessage';
import MessageDetail from './MessageDetail';
import MessageTemplatesModal from '../../../../neoverv/components/Module/General/CustomModal/MessageTemplatesModal';
import { connect } from 'react-redux';
import MessageTemplates from '../../../../neoverv/components/Module/General/MessageTemplates/MessageTemplates';
import { Group, Stack } from '@mantine/core';
import breadcrumbsContent from '../../../../../src/assets/breadcrumbs.json';
import HelpLogo from '../../../../assets/images/module/general/book.svg';
import TourIcon from '../../../../assets/images/module/general/TourIcon.svg';
import CrossIcon from '../../../../assets/images/module/general/CrossIcon.svg';
import HeadingContainerNew from '../../../../neoverv/components/Module/General/HeadingContainerNew';

var Setting = Autoload.Setting;
var lang = Setting[Setting.language_default];
const { loader, checkProperty } = Autoload.MainHelper;

const MOBILE_SIZE = 992;

const routes = [
  {
    name: 'messaging',
    className: 'tooltips messaging',
    route: '/messaging',
    label: 'Messaging',
    heading: 'Nachrichten',
    includeInTab: true
  },
  {
    name: 'templates',
    className: 'tooltips templates',
    route: '/messaging/templates',
    label: 'Vorlagen',
    heading: 'Vorlagen',
    includeInTab: true
  },
  {
    name: 'messsageDetails',
    className: 'tooltips messaging',
    route: '/messaging/messageDetail',
    label: 'Nachricht anzeigen',
    heading: 'Nachricht anzeigen',
    includeInTab: false
  },
  {
    name: 'newMessage',
    className: 'tooltips messaging',
    route: '/messaging/newMessage',
    label: 'Nachricht erstellen',
    heading: 'Nachricht erstellen',
    includeInTab: false
  },
//   {
//     name: 'master',
//     className: 'tooltips data-transfer',
//     route: '/meter/data_transfer',
//     label: 'Datentransfer',
//     heading: 'Datentransfer',
//   },
];

class List extends Component {
  state = {
    active: '/meter/reading',
    isMobile: window.innerWidth <= MOBILE_SIZE,
    openNewMessage: false,
    search: ''
  };
  changePage(route) {
    this.setState({ active: route });
    this.props.history.push(route);
    //Autoload.MainHelper.redirection(route);
  }
  changeHeading() {
    const activeRoute = routes.filter((route) => {
      return window.location.pathname === route.route;
    });
    const heading = activeRoute.length > 0 ? activeRoute[0].heading : routes[0].heading;
    return (
      <Group>
        {(window.location.href.includes('/newMessage') || window.location.href.includes('/messageDetail')) && <img src={CrossIcon} alt='cross-icon' id={'utility-message-draft-cross-desktop'} style={{cursor: 'pointer'}} onClick={()=> this.backButtonOnClick()}/>}
        {heading}
      </Group>);
  }

  componentDidMount(){
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    // TODO: this causes data refetch on the meters reading details screen...
    if (window.innerWidth <= MOBILE_SIZE) {
      this.setState({ isMobile: true });
    } else {
      this.setState({ isMobile: false });
    }
  };

  renderNewMessageButton=()=>{
      const {selectedTenantId, formData} = this.props;
      return <ColorButton
      text={'Neue Nachricht'}
      className={'purple-btn'}
      onClick={()=> {
        if(selectedTenantId){
          this.props.history.push('/messaging/newMessage', {
            tenantId: selectedTenantId,
            messageType: 'Tenant',
            createNewTenantMessage: true,
            previousUrl: selectedTenantId ? `/user/tenant/information?tenantId=${selectedTenantId}` : null
          });
        }else{
          this.setState({openMessageTypeSelectionModal: true});
        }
      }} //this.props.history.push('/messaging/newMessage')
      textStyle={{whiteSpace: 'nowrap'}}
      />
  }

  handleSearchHandler=(e)=>{
    this.setState({search: e.target.value});
  }

  backButtonOnClick=()=>{
    const templateId = this.props.location.state ? this.props.location.state.templateId !== undefined ? this.props.location.state.templateId : null : null;
    const forward = this.props.location.state ? this.props.location.state.forward !== undefined ? this.props.location.state.forward : false : false;
    const replyAll = this.props.location.state ? this.props.location.state.replyAll !== undefined ? this.props.location.state.replyAll : false : false;

    if(replyAll || forward || templateId){
      return null;
    }else{
      const {currentMessageData} = this.props;
      const previousUrl = this.props.location.state ? this.props.location.state.previousUrl : null;
      loader(true);
      setTimeout(() => {
        loader(false);
        console.log('previousUrl: ', this.props.history);
        
        if(currentMessageData?.templateType === 'RentalPayment'){
          if(previousUrl){
            this.props.history.push(previousUrl, {comingFromRoute: 'messages', open: 'rentIncomeTracking'});
          }else{
            this.props.history.push('/user/rentIncomeTracking');
          }
        }else if(currentMessageData?.templateType === 'TenantSignUp'){
          this.props.history.push('/tenantPortal');
        }else{
          if(previousUrl){
            this.props.history.push(previousUrl, {comingFromRoute: 'messages', open: 'messages'});
          }else{
            this.props.history.push('/messaging');
          }
        }
        //this.props.history.push(window.location.href.includes('/newMessage') ? '/messaging/messages' : window.location.href.includes('/messageDetail') && '/messaging/messages');
      }, 600);
    }
    
    
  }

  render() {
    const {isMobile, openNewMessage, search} = this.state;
    const {currentMessageData} = this.props;

    console.log('currentMessageData: ', currentMessageData);
    let pathname = this.props.location.pathname;

    console.log('this.props.history: ', this.props.history);
    // const selectedTenantId = false;
    const showTabBar = pathname === '/messaging' || pathname.includes('/messaging/templates');
    let templatesScreen = pathname.includes('/messaging/templates');
    return (
      <div className="meterClass">
        {!isMobile && <HeadingContainerNew
        heading={this.changeHeading()}
        //hideHeadingTextWrapper={isMobile}
        headingClassName={'messaging-heading tooltips'}
        className="messaging-container mb-0"
        rightContent={(window.location.href.includes('/newMessage') || window.location.href.includes('/messageDetail')) &&
          <ColorButton
          id={'utility-message-draft-3'}
          text={'Zurück'}
          className={'gray-btn'}
          onClick={()=> this.backButtonOnClick()}
          />
        }
        breadcrumbs={showTabBar &&
        breadcrumbsContent.map((item)=> item.area === '/messaging' && 
          item.breadcrumbs.filter((breadcrumb) => templatesScreen ? breadcrumb.type === 'knowledge' : breadcrumb).map((breadcrumb)=>
          breadcrumb.type === 'tour' ? breadcrumb.view === 'desktop' && !isMobile &&
          <div style={{display: 'flex', width: 'auto', alignItems: 'center', cursor: 'pointer', marginRight: '22px'}} onClick={()=> window.Intercom('startTour', breadcrumb.id)}>
              <img src={TourIcon} />
              <span style={{color: '#5555FF', marginLeft: '5px', fontSize: '14px', whiteSpace: 'nowrap'}}>{breadcrumb.label}</span>
          </div>
          :
          breadcrumb.view === 'desktop' &&
          <div style={{display: 'flex', width: 'auto', alignItems: 'center', cursor: 'pointer', marginRight: '22px'}} onClick={()=> window.Intercom('showArticle', breadcrumb.id)}>
              <img src={HelpLogo} />
              <span style={{color: '#5555FF', marginLeft: '5px', fontSize: '14px', whiteSpace: 'nowrap'}}>{breadcrumb.label}</span>
          </div>
          )
        )}
        breadcrumbsClassName={'messaging-breadcrumbs'}
        />}
        {showTabBar &&
        <>
          <div style={{ display: 'flex', cursor: 'pointer', overflowX: 'scroll' }} className='property-navbar'>
            {routes.filter((route)=> route.includeInTab).map((btn, idx) => {
                console.log('pathname: ', pathname, btn.route);
                return (
                  <p
                    key={idx}
                    className={`switch-btn ${btn.name}-btn ${btn.route === pathname && 'active'}`}
                    style={{
                      color: btn.route === pathname ? '#111147' : '#727293',
                      borderBottom: btn.route === pathname ? '3px solid #5555FF' : null,
                      fontSize: btn.route === pathname ? '14px' : '14px',
                      marginRight: '25px',
                      padding: '20px 0px'
                    }}
                    onClick={() => {
                      this.changePage(btn.route);
                    }}
                  >
                    {btn.heading}
                  </p>
                );
            })}
          </div>
          <hr style={{ marginTop: '-18px' }} />
        </>}

        {/* <FiltersContainer
            style={{marginBottom: isMobile && '0px', alignItems: 'flex-end'}}
            searchElement={
                <Stack style={{width: isMobile && '100%'}}>
                    <Group style={{width: isMobile ? '100%' : selectedTenantId ? '202px' : '300px'}} wrap="nowrap" justify="space-between">
                        <SearchContainer
                        placeholder={selectedTenantId ? 'Nachrichten durchsuchen' : 'Inhalt, Empfänger'}
                        value={search}
                        onChange={this.handleSearchHandler}
                        disabled={false}
                        className={isMobile ? "mobile-annual-reading-search" : "annual-reading-search"}
                        />
                        {isMobile && 
                        <div>
                          {this.renderNewMessageButton()}
                        </div>}
                    </Group>
                </Stack>
            }
            sortElement={!isMobile && this.renderNewMessageButton()}
        /> */}
        {/* {!selectedTenantId && <div className="divider" style={{marginTop: isMobile && '0px'}}></div>} */}
        
        <div>
          <Route path={this.props.match.url} exact //component={MessagesList} 
          render={(props)=> <MessagesList {...props} isMobile={isMobile} openNewMessage={openNewMessage} setOpenNewMessage={(value)=> this.setState({openNewMessage: value})} search={search}/>}/>
          <Route path={this.props.match.url + '/messages'} exact //component={MessagesList} 
          render={(props)=> <MessagesList {...props} isMobile={isMobile} openNewMessage={openNewMessage} setOpenNewMessage={(value)=> this.setState({openNewMessage: value})} search={search}/>}/>
          <Route path={this.props.match.url + '/newMessage'} exact //component={NewMessage} 
          render={(props)=> <NewMessage {...props} isMobile={isMobile}/>}/>
          <Route path={this.props.match.url + '/messageDetail'} exact //component={MessageDetail} 
          render={(props)=> <MessageDetail {...props} isMobile={isMobile}/>}/>
          <Route path={this.props.match.url + '/templates'} exact //component={MessagesList} 
          render={(props)=> <MessageTemplates {...props} isMobile={isMobile}/>}/>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
      currentMessageData: state.generalReducer.currentMessageData,
  };
};

export default connect(mapStateToProps)(withRouter(List));
